import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type BoardTileLargeFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id' | 'dateLastActivity' | 'dateLastView' | 'name' | 'premiumFeatures' | 'shortLink' | 'starred'>
  & { prefs?: Types.Maybe<(
    { __typename: 'Board_Prefs' }
    & Pick<Types.Board_Prefs, 'background' | 'backgroundBottomColor' | 'backgroundBrightness' | 'backgroundColor' | 'backgroundImage' | 'backgroundTile' | 'backgroundTopColor' | 'isTemplate' | 'permissionLevel'>
    & { backgroundImageScaled?: Types.Maybe<Array<(
      { __typename: 'Board_Prefs_BackgroundImageScaled' }
      & Pick<Types.Board_Prefs_BackgroundImageScaled, 'height' | 'url' | 'width'>
    )>> }
  )> }
);

export const BoardTileLargeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardTileLarge' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastActivity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prefs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'background' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundBottomColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundBrightness' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundImage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundImageScaled' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'height' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundTile' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundTopColor' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissionLevel' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumFeatures' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'starred' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseBoardTileLargeFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      BoardTileLargeFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseBoardTileLargeFragmentResult
  extends Omit<Apollo.UseFragmentResult<BoardTileLargeFragment>, 'data'> {
  data?: BoardTileLargeFragment;
}

export const useBoardTileLargeFragment = ({
  from,
  returnPartialData,
  ...options
}: UseBoardTileLargeFragmentOptions): UseBoardTileLargeFragmentResult => {
  const result = Apollo.useFragment<BoardTileLargeFragment>({
    ...options,
    fragment: BoardTileLargeFragmentDoc,
    fragmentName: 'BoardTileLarge',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as BoardTileLargeFragment };
};
